export const SIDEBAR_Z_INDEX = 1000;